// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__8XSUE","label":"Category_label__nKHVs","content":"Category_content__2t4Sv","header":"Category_header__BsA5S","location":"Category_location__2DUko"};